module.exports = __webpack_public_path__ + "static/img/faInspection.9528a496.png";